import type {
	MarketingContextResponse,
	MarketingProvidersResponse,
	MarketingRunListResponse,
	MarketingRunsSummaryResponse,
	MarketingTaskType,
	MarketingTimezonesResponse,
} from "@/shared/api/generated/types/marketing"

import { listMarketingTaskItems } from "./marketing-task-store"

export const marketingContextFixture: MarketingContextResponse = {
	marketingEnabled: true,
	marketingAccepted: false,
	marketingSmsBalance: 12450,
	sendLimit: 5000,
	defaultTimezone: "Europe/Moscow",
}

export const marketingTimezonesFixture: MarketingTimezonesResponse = {
	timezones: [
		{
			id: "Europe/Moscow",
			label: "Москва · UTC+3 — пояс бизнеса",
			offset: "UTC+3",
			isBusinessDefault: true,
		},
		{
			id: "Asia/Yekaterinburg",
			label: "Екатеринбург · UTC+5",
			offset: "UTC+5",
			isBusinessDefault: false,
		},
	],
}

export const marketingProvidersFixture: MarketingProvidersResponse = {
	providers: [
		{
			id: "provider-main",
			name: "Основной провайдер",
			channels: ["sms", "whatsapp", "telegram", "viber", "max"],
		},
	],
}

export const marketingRunsSummaryFixture: MarketingRunsSummaryResponse = {
	runsCount: 6,
	deliveredCount: 885,
	deliveredPercent: 95,
	exportsCount: 2,
	errorsCount: 48,
}

export const marketingRunsListFixture: MarketingRunListResponse = {
	data: [
		{
			id: "run-mailing-001",
			runAt: "2026-05-28T07:02:00.000Z",
			taskId: "task-mailing-birthday",
			taskName: "Скидки именинникам",
			taskType: "mailing",
			scheduleKind: "recurring",
			recipientsCount: 132,
			providerLabel: "Мессенджеры",
			deliveredCount: 124,
			errorsCount: 8,
			deliveryPercent: 94,
		},
		{
			id: "run-mailing-002",
			runAt: "2026-05-25T08:00:00.000Z",
			taskId: "task-mailing-recall",
			taskName: "Возврат «спящих» 90+",
			taskType: "mailing",
			scheduleKind: "recurring",
			recipientsCount: 836,
			providerLabel: "SMS",
			deliveredCount: 389,
			errorsCount: 29,
			deliveryPercent: 93,
		},
		{
			id: "run-mailing-003",
			runAt: "2026-05-21T11:30:00.000Z",
			taskId: "task-mailing-reminder",
			taskName: "Напоминание о записи",
			taskType: "mailing",
			scheduleKind: "once",
			recipientsCount: 287,
			providerLabel: "SMS",
			deliveredCount: 280,
			errorsCount: 7,
			deliveryPercent: 98,
		},
		{
			id: "run-mailing-004",
			runAt: "2026-05-18T06:15:00.000Z",
			taskId: "task-mailing-welcome",
			taskName: "Новые пациенты — приветствие",
			taskType: "mailing",
			scheduleKind: "recurring",
			recipientsCount: 96,
			providerLabel: "Мессенджеры",
			deliveredCount: 92,
			errorsCount: 4,
			deliveryPercent: 96,
		},
		{
			id: "run-export-001",
			runAt: "2026-05-28T06:40:00.000Z",
			taskId: "task-report-birthdays",
			taskName: "Список именинников недели",
			taskType: "report",
			scheduleKind: "once",
			recipientsCount: 132,
			providerLabel: ".xlsx · 132 строки · 3 поля",
			deliveredCount: 132,
			errorsCount: 0,
			deliveryPercent: 100,
			fieldsCount: 3,
			rowsCount: 132,
		},
		{
			id: "run-export-002",
			runAt: "2026-05-20T05:00:00.000Z",
			taskId: "task-report-weekly",
			taskName: "Еженедельный отчёт по филиалам",
			taskType: "report",
			scheduleKind: "recurring",
			recipientsCount: 1940,
			providerLabel: ".xlsx · 1 940 строк · 4 поля · на reports@clinic.ru",
			deliveredCount: 1940,
			errorsCount: 0,
			deliveryPercent: 100,
			fieldsCount: 4,
			rowsCount: 1940,
		},
	],
	paging: { page: 1, pageSize: 20, total: 6 },
}

export function getMarketingTaskListFixture(
	type: MarketingTaskType | null,
	scheduleFilter?: "all" | "once" | "recurring" | null,
	page = 1,
	pageSize = 20,
) {
	const data = listMarketingTaskItems(type, scheduleFilter)
	const total = data.length
	const start = (page - 1) * pageSize

	return {
		data: data.slice(start, start + pageSize),
		paging: { page, pageSize, total },
	}
}
